import { GetDeal_deal_car_prices_totalFeatures } from '../../graphql/queries/__generated__/GetDeal';
import usePrice from './usePrice';

const useTotalFeatures = (totalFeatures: GetDeal_deal_car_prices_totalFeatures[]) => {
  const { primaryPrice: primaryTotalFeaturesPrices, secondaryPrice: secondaryTotalFeaturesPrices } = usePrice(
    totalFeatures,
  );

  return [primaryTotalFeaturesPrices, secondaryTotalFeaturesPrices];
};

export default useTotalFeatures;
